// src/components/CookieBanner.js
import { useEffect, useState } from 'react';
import './CookieBanner.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCookieBite, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'; // NEW

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) setVisible(true);
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie_consent', 'true');
    setVisible(false);
  };

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const resetConsent = () => {
    localStorage.removeItem('cookie_consent');
    setVisible(true);
    setShowPopup(false);
  };

  return (
    <>
      {visible && (
        <div className="cookie-banner">
          <p>
            We use cookies to ensure you get the best experience. See our{' '}
            <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
          </p>
          <button onClick={acceptCookies}>Accept</button>
        </div>
      )}
    
      {/* Floating cookie icon */}
      <div
        className={`cookie-float-icon ${visible ? 'with-banner' : ''}`}
        onClick={togglePopup}
        title="Cookie Preferences"
      >
        <FontAwesomeIcon icon={faCookieBite} />
      </div>
    
      {/* Floating WhatsApp icon (separate) */}
      <a
        href="https://wa.me/918861494444"
        target="_blank"
        rel="noopener noreferrer"
        className={`whatsapp-float-icon ${visible ? 'with-banner' : ''}`}
        title="Chat with us on WhatsApp"
      >
        <FontAwesomeIcon icon={faWhatsapp} />
      </a>
    
      {/* Cookie preferences popup */}
      {showPopup && (
        <div className="cookie-popup">
          <div className="popup-header">
            <h4>Cookie Settings</h4>
            <FontAwesomeIcon icon={faTimes} onClick={togglePopup} className="close-icon" />
          </div>
          <p>We use cookies to personalize content and improve your experience.</p>
          <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">View Privacy Policy</a>
          <button onClick={resetConsent}>Reset Consent</button>
        </div>
      )}
    </>  
  );
}
